module.exports = __webpack_public_path__ + "static/media/Matt-Wilson-BunnyLever.4b8e1334.png";